/* eslint-disable */
export default {
  /**
   * Checks if page is vode node or not
   * 
   * @returns {boolean}
   */
  isVod () {
      if (window.location.href.match(/\/media\/videos\/[\S]+/) || window.location.href.match(/\/media\/video\/[\S]+/)) {
       return true;
      } else {
        return false;
      }
  },
  /**
   * Pulls page values and assigns to VAST tag.
   *
   * @param item
   * @returns {*}
   */
  videoPlayerGetValueFromPage(item) {
        var response = 'null';
        switch (item) {
            case 'ftag_value':
                if (typeof site !== 'undefined') {
                    if (typeof site.ftag !== 'undefined') {
                        return site.ftag;
                    }
                    if (typeof site.campaign !== 'undefined') {
                        return site.campaign;
                    }
                }
                if (typeof ftag !== 'undefined') {
                    return ftag;
                }
                if (this.videoPlayerGetValueFromUrl('ftag')) {
                    return this.videoPlayerGetValueFromUrl('ftag');
                }
                break;
            case 'vguid_value':
                if (typeof site !== 'undefined') {
                    if (typeof site.vguid !== 'undefined') {
                        return site.vguid;
                    }
                    if (typeof site.viewguid !== 'undefined') {
                        return site.viewguid;
                    }
                    if (typeof site.uuid !== 'undefined') {
                        return site.uuid;
                    }
                }
                if (typeof window.uuid !== 'undefined') {
                    return window.uuid;
                }
                if (this.videoPlayerGetValueFromUrl('viewguid')) {
                    return this.videoPlayerGetValueFromUrl('viewguid');
                }
                break;
            case 'section_value':
                if (typeof site !== 'undefined') {
                    if (typeof site.section !== 'undefined') {
                        return site.section;
                    }
                }
                if (this.videoPlayerGetValueFromUrl('section')) {
                    return this.videoPlayerGetValueFromUrl('section');
                }
                break;
        }

        return response;
  },
  /**
   * Not sure what this is for
   * 
   * @param {string} item
   * @returns {?string}
   */
  videoPlayerGetValueFromUrl(item) {
        var url = window.location.href;
        item = item.replace(/[\[\]]/g, '\\$&');

        var regex = new RegExp('[?&]' + item + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results || !results[2]) {
            return null;
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
